import { Component, OnInit } from '@angular/core';
import { BaseTabsUpdateComponent, TabsContainerService, BaseDataService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { FinDokument } from './fin-dokument';

@Component({
  selector: 'yt-fin-dokument-tab-update',
  templateUrl: './fin-dokument-tab-update.component.html'
})
export class FinDokumentTabUpdateComponent extends BaseTabsUpdateComponent<FinDokument> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected tabsContainerService: TabsContainerService<FinDokument>,
    protected baseDataService: BaseDataService,
    protected userService: UserService
  ) {
    super(activatedRoute, tabsContainerService, baseDataService, userService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

}
